import { render, staticRenderFns } from "./tunjanganTidakTetap.vue?vue&type=template&id=b0469506"
import script from "./tunjanganTidakTetap.vue?vue&type=script&lang=js"
export * from "./tunjanganTidakTetap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports